import AuthlessA5PrintPage from "@/components/common-receipt/AuthlessA5PrintPage";
import {
  depositReceiptA5Props,
  type DepositReceiptPrintRecord,
} from "./deposit-receipt-print-content";

const DepositReceiptPrint = () => (
  <AuthlessA5PrintPage<DepositReceiptPrintRecord>
    location="contRcpt"
    toProps={depositReceiptA5Props}
  />
);

export default DepositReceiptPrint;
